export class Container {
  private instances: Map<string, any> = new Map();

  register<T>(id: string, instance: T): void {
    this.instances.set(id, instance);
  }

  resolve<T>(id: string): T {
    const instance = this.instances.get(id);
    if (!instance) {
      throw new Error(`Container error. No instance of id '${id}' found.`);
    }
    return instance as T;
  }
}
